import React from "react";
import {Button, Typography} from "@mui/material";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * 기록 상세 화면(식사·운동·수분·걸음수) 공통 조회 상태 표시.
 *
 * 네 화면 모두 조회가 끝나기 전에는 수치가 0 으로만 보이고 아무 표시가 없어서,
 * 응답이 400ms 남짓인데도 "느리다 / 멈췄다" 로 보였다. 실패했을 때도 마찬가지로
 * 조용히 0 만 남아 사용자가 원인을 알 수 없었다.
 *
 * 화면마다 레이아웃이 달라 값 자리를 대체하지 않고, 날짜 아래 한 줄만 차지한다.
 */
const HistoryLoadState = (props: { loading: boolean, failed: boolean, onRetry: () => void }) => {
  if (props.loading) {
    return (
      <Stack direction={'row'} alignItems={'center'} justifyContent={'center'} spacing={1} sx={{ height: 32 }}>
        <CircularProgress size={16} sx={{ color: '#59b544' }} />
        <Typography sx={{ fontSize: 13, color: '#888' }}>불러오는 중…</Typography>
      </Stack>
    );
  }

  if (props.failed) {
    return (
      <Stack direction={'row'} alignItems={'center'} justifyContent={'center'} sx={{ height: 32 }}>
        <Typography sx={{ fontSize: 13, color: '#888' }}>기록을 불러오지 못했습니다.</Typography>
        <Button onClick={props.onRetry} sx={{ fontSize: 13, fontWeight: 700, color: '#EF8322', minWidth: 0, ml: 1 }}>
          다시 시도
        </Button>
      </Stack>
    );
  }

  // 성공 시에도 자리를 남겨 둔다 — 조회가 끝날 때 아래 내용이 위로 튀지 않게
  return <Box sx={{ height: 32 }} />;
}

export default HistoryLoadState;
